// 密码校验
export function validatePassword (rule, value, callback) {
  if (value === '' || value === undefined || value === null || value === '123456') {
    return callback()
  }
  if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/.test(value)) {
    callback(new Error('密码不能少于8位,且必须有数字字母组合'))
  } else {
    callback()
  }
}
// 手机号
export const validatePhone = (rule, value, callback) => {
  const numberReg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/
  if (value === '' || value === undefined || value === null) {
    return callback()
  }
  if (value !== '') {
    if (!numberReg.test(value)) {
      callback(new Error('请输入正确的手机号'))
    } else {
      callback()
    }
  }
}

// 邮箱 
export const validatemail = (rule, value, callback) => {
  const numberReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (value === '' || value === undefined || value === null) {
    return callback()
  }
  if (value !== '') {
    if (!numberReg.test(value)) {
      callback(new Error('请输入正确的邮箱'))
    } else {
      callback()
    }
  }
}
// 银行账号
export const validatkhzh = (rule, value, callback) => {
  const numberReg = /^[1-9]\d{9,29}$/
  if (value === '' || value === undefined || value === null) {
    return callback()
  }
  if (value !== '') {
    if (!numberReg.test(value)) {
      callback(new Error('请输入正确的银行账号'))
    } else {
      callback()
    }
  }
}